import { Box, useTheme } from '@mui/material';
import { Card } from '../../../shared/components/ui/Card';
import { useAnnouncement } from '../context/useAnnouncement';
import { PageHeader } from '../components/AnnouncementList/PageHeader';

import { ModalDelete } from '../components/ModalDelete';
import { AnnouncementTable } from '../components/AnnouncementList/AnnouncementTable';

export default function AnnouncementListPage() {
   const theme = useTheme();
  const { 
    announcements, 
    isLoading, 
    navigateToCreate,
    isDeleteModalOpen,
    closeDeleteModal,
    handleDeleteAnnouncement,
    isDeleting,
    selectedAnnouncement
  } = useAnnouncement();

  return (
    <Box style={{ 
      background: theme.palette.background.paper, 
      borderRadius: 16, 
      padding: 32, 
      boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)', 
      maxWidth: '100%', 
      margin: '0 auto' 
    }}>

        <PageHeader onAdd={navigateToCreate} isLoading={isLoading} />
        <AnnouncementTable announcements={announcements} isLoading={isLoading} />
        
        <ModalDelete
          open={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDeleteAnnouncement}
          loading={isDeleting}
          title={selectedAnnouncement?.title || ''}
        />
   
    </Box>
  );
}